<div class="u-wordWrap-breakWord">
  <div
    *ngIf="group?.is_role_selectable_for_user_introduction_goals ?? true"
    class="u-marginBottom-16 u-paddingBottom-16 u-text-maxWidth"
    [ngClass]="{ 'u-borderBottom-grey100': customSegmentsToShow?.length }"
  >
    <p
      i18n="@@global.role"
      class="color-grey-300 text-caption u-marginBottom-16 u-marginTop-16"
    >
      Role
    </p>
    <ng-container *ngIf="!allOptionsSelected.roles">
      <ng-container *ngTemplateOutlet="disclaimerBlock"></ng-container>
    </ng-container>
    <mat-chip-listbox>
      <div *ngFor="let role of group.roles">
        <ng-container *ngIf="!isRoleSelectable(role.name)">
          <mat-chip-option
            *ngIf="userRole"
            i18n-matTooltip="
              @@introductionsView.groupIntroSelectionsForm.lockedTooltip"
            matTooltip="Locked by your admin"
            matTooltipPosition="above"
            selectable="false"
          >
            <mat-icon class="u-marginRight-8 color-grey-300 md-18">
              lock
            </mat-icon>
            <span>{{ role.name | translationLookup: ['@@groupRole'] }}</span>
          </mat-chip-option>
          <mat-chip-option
            *ngIf="!userRole"
            i18n-matTooltip="
              @@introductionsView.groupIntroSelectionsForm.unlockRoleTooltip"
            matTooltip="Fill out your role to unlock"
            matTooltipPosition="above"
            selectable="false"
          >
            <button class="c-button">
              <mat-icon class="u-marginRight-8 color-grey-300 md-18">
                lock
              </mat-icon>
            </button>
            {{ role.name | translationLookup: ['@@groupRole'] }}
          </mat-chip-option>
        </ng-container>
        <ng-container *ngIf="isRoleSelectable(role.name)">
          <mat-chip-option
            (click)="
              toggleRoleSelection(roleSelections, role.name);
              emitChanges(
                roleSelections,
                customSegmentSelections,
                hiddenCustomSegmentSelections
              )
            "
            [ngStyle]="{ cursor: 'pointer' }"
            selectable="false"
          >
            <div fxLayout="row" fxLayoutAlign="start center">
              <mat-icon
                *ngIf="roleSelections[role.name]"
                class="u-marginRight-8 color-teal-700"
                [@fadeInEnter]
              >
                check_circle
              </mat-icon>
              <mat-icon
                *ngIf="!roleSelections[role.name]"
                class="u-marginRight-8 color-grey-300"
                [@fadeInEnter]
              >
                radio_button_unchecked
              </mat-icon>
              <span>
                {{ role.name | translationLookup: ['@@groupRole'] }}
              </span>
            </div>
          </mat-chip-option>
        </ng-container>
      </div>
    </mat-chip-listbox>
  </div>
  <ng-container
    [ngTemplateOutlet]="customSegmentsSelectionForm"
    [ngTemplateOutletContext]="{
      segmentsToShow: customSegmentsToShow,
      segmentsSelected: customSegmentSelections,
    }"
  ></ng-container>
  <ng-container
    *ngIf="showHiddenCustomSegments && hiddenCustomSegmentsToShow.length"
    [ngTemplateOutlet]="customSegmentsSelectionForm"
    [ngTemplateOutletContext]="{
      segmentsToShow: hiddenCustomSegmentsToShow,
      segmentsSelected: hiddenCustomSegmentSelections,
    }"
  ></ng-container>
</div>
<ng-template #disclaimerBlock>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="8px"
    class="u-padding-8 u-border-orange u-marginBottom-16 u-borderRadius--4px"
  >
    <mat-icon class="color-orange">info</mat-icon>
    <p i18n="@@introductionsView.groupIntroSelectionsForm.matchDisclaimer">
      You won't get matched with people in unchecked category.
    </p>
  </div>
</ng-template>
<ng-template
  #customSegmentsSelectionForm
  let-segmentsToShow="segmentsToShow"
  let-segmentsSelected="segmentsSelected"
>
  <div *ngFor="let segment of segmentsToShow; let last = last">
    <div
      class="u-marginBottom-16 u-paddingBottom-16 u-text-maxWidth"
      [ngClass]="{ 'u-borderBottom-grey100': !last }"
    >
      <p class="color-grey-300 text-caption u-marginBottom-16">
        {{ segment.title | translationLookup: ['@@groupCustomSegmentTitle'] }}
      </p>
      <ng-container *ngIf="false === allOptionsSelected[segment._id]">
        <ng-container *ngTemplateOutlet="disclaimerBlock"></ng-container>
      </ng-container>
      <mat-chip-listbox>
        <div *ngFor="let node of segment.nodes">
          <ng-container *ngIf="!isNodeSelectable(segment._id, node.name)">
            <mat-chip-option
              *ngIf="userCustomSegments[segment._id]"
              i18n-matTooltip="
                @@introductionsView.groupIntroSelectionsForm.lockedTooltip"
              matTooltip="Locked by your admin"
              matTooltipPosition="above"
              selectable="false"
            >
              <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="u-marginRight-8 color-grey-300 md-18">
                  lock
                </mat-icon>
                <span>
                  {{
                    node.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  }}
                </span>
              </div>
            </mat-chip-option>
            <mat-chip-option
              *ngIf="!userCustomSegments[segment._id]"
              i18n-matTooltip="
                @@introductionsView.groupIntroSelectionsForm.unlockSegmentTooltip"
              matTooltip="Fill out your {{ segment.title }} to unlock"
              matTooltipPosition="above"
              selectable="false"
            >
              <div fxLayout="row" fxLayoutAlign="start center">
                <button class="c-button">
                  <mat-icon class="u-marginRight-8 color-grey-300 md-18">
                    lock
                  </mat-icon>
                </button>
                <span>
                  {{
                    node.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  }}
                </span>
              </div>
            </mat-chip-option>
          </ng-container>
          <ng-container *ngIf="isNodeSelectable(segment._id, node.name)">
            <mat-chip-option
              (click)="
                toggleCustomSegmentSelection(
                  segmentsSelected,
                  segment._id,
                  node.name
                );
                emitChanges(
                  roleSelections,
                  customSegmentSelections,
                  hiddenCustomSegmentSelections
                )
              "
              [ngStyle]="{ cursor: 'pointer' }"
              selectable="false"
            >
              <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon
                  *ngIf="segmentsSelected[segment._id][node.name]"
                  class="u-marginRight-8 color-teal-700"
                  [@fadeInEnter]
                >
                  check_circle
                </mat-icon>
                <mat-icon
                  *ngIf="!segmentsSelected[segment._id][node.name]"
                  class="u-marginRight-8 color-grey-300"
                  [@fadeInEnter]
                >
                  radio_button_unchecked
                </mat-icon>
                <span>
                  {{
                    node.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  }}
                </span>
              </div>
            </mat-chip-option>
          </ng-container>
        </div>
      </mat-chip-listbox>
    </div>
  </div>
</ng-template>
